import { useEffect, useState } from 'react'
import { useSearchParams, Link, useNavigate } from 'react-router-dom'
import { customerApi, setCustomerToken } from '../../services/customerAuth'
import { useLanguage } from '../../context/LanguageContext'

export default function VerifyEmail() {
  const { t } = useLanguage()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get('token')
  const [state, setState] = useState('working') // working | success | already | error
  const [message, setMessage] = useState('')
  const [boundCount, setBoundCount] = useState(0)

  useEffect(() => {
    if (!token) {
      setState('error')
      setMessage(t('sp_verify_link_missing', 'Verification link is missing its token.'))
      return
    }
    customerApi.post('/customer/verify-email', { token })
      .then(({ data }) => {
        if (data.token) setCustomerToken(data.token)
        if (data.alreadyVerified) setState('already')
        else setState('success')
        setBoundCount(data.boundBookings || 0)
        setMessage(data.message || '')
      })
      .catch(err => {
        setState('error')
        setMessage(err.response?.data?.message || t('sp_verification_failed', 'Verification failed'))
      })
  }, [token])

  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '60px 16px', fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif" }}>
      <div style={{ maxWidth: 460, margin: '0 auto', background: '#fff', padding: 32, borderRadius: 12, textAlign: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
        {state === 'working' && <><h2>{t('sp_verifying', 'Verifying…')}</h2><p style={{ color: '#64748b' }}>{t('sp_one_moment', 'One moment.')}</p></>}
        {state === 'success' && (
          <>
            <h2 style={{ color: '#153230', margin: '0 0 12px' }}>{t('sp_email_verified', 'Email verified')}</h2>
            {boundCount > 0
              ? <p style={{ color: '#475569' }}>{t('sp_we_found', 'We found')} <strong>{boundCount}</strong> {t('sp_existing_booking', 'existing booking')}{boundCount !== 1 ? 's' : ''} {t('sp_and_added', 'and added')} {boundCount === 1 ? t('sp_it', 'it') : t('sp_them', 'them')} {t('sp_to_your_account', 'to your account.')}</p>
              : <p style={{ color: '#475569' }}>{t('sp_account_active', 'Your account is now active.')}</p>}
            <button onClick={() => navigate('/customer/dashboard')} style={btnPrimary}>{t('sp_go_to_my_bookings', 'Go to my bookings')}</button>
          </>
        )}
        {state === 'already' && (
          <>
            <h2 style={{ color: '#153230' }}>{t('sp_already_verified', 'Already verified')}</h2>
            <p style={{ color: '#475569' }}>{t('sp_account_already_active', 'Your account is already active.')}</p>
            <Link to="/customer/login" style={{ ...btnPrimary, display: 'inline-block', textDecoration: 'none' }}>{t('sp_log_in', 'Log in')}</Link>
          </>
        )}
        {state === 'error' && (
          <>
            <h2 style={{ color: '#991b1b' }}>{t('sp_verification_failed', 'Verification failed')}</h2>
            <p style={{ color: '#64748b' }}>{message}</p>
            <Link to="/customer/signup" style={{ color: '#00d19f', fontWeight: 600 }}>{t('sp_sign_up_again', 'Sign up again')}</Link>
          </>
        )}
      </div>
    </div>
  )
}

const btnPrimary = {
  padding: '12px 24px', background: '#00d19f', color: '#153230',
  border: 'none', borderRadius: 6, fontWeight: 700, fontSize: 15, cursor: 'pointer',
  marginTop: 14,
}
